<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras nombre_ruta="quienesSomos"></boton-atras>

             <div>
                <div>
                    <h6 class="subtitulo mb-2">Misión y Visión</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                <h5 class="mt-5">Misión</h5>
                </div>
                <p class="parrafo-contenido">
                   Administrar los recursos destinados a cubrir el costo de las reparaciones por siniestros que ocurran a vehículos propiedad del Poder Ejecutivo del Estado y daños que estos ocasionen a terceros, fungiendo de manera similar a una institución aseguradora, con la finalidad de preservar el parque vehicular de las Dependencias, Entidades, Organismos Desconcentrados, Unidades Administrativas y Fideicomisos Públicos del Poder Ejecutivo del Estado, como alternativa menos onerosa. 
                </p>               
            </div>
             <div>
                <h5 class="mt-5">Visión</h5>
                <p class="parrafo-contenido">
                   Operar como una aseguradora de cobertura amplia, atendiendo con calidad, eficiencia y eficacia, los siniestros que ocurran a los vehículos propiedad del Poder Ejecutivo del Estado, en apego a las disposiciones de la normatividad vigente. 
                </p>               
            </div>
            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        botonAtras
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>

/* @media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
} */

</style>